import * as React from 'react';
import { Image, Modal } from 'semantic-ui-react';

export interface Props {
    headerText: string;
    open: boolean;
    modalProps: object;

    children: JSX.Element;

    showHeaderClose?: boolean;
    closeHandler: () => void;

    footerClassName?: string;
    actionButton?: JSX.Element;
}

export class BaseModal extends React.Component<Props, {}> {
    public render() {
        const props = this.props;

        const footerClassName = this.props.footerClassName === undefined ? 'modal-footer' : this.props.footerClassName;

        function getActionButton() {
            if (props.actionButton !== undefined) {
                let actionButtonProps = {
                  ...props.actionButton.props,
                  className: props.actionButton.props.className
                    ? 'modal-confirm ' + props.actionButton.props.className
                    : 'modal-confirm'
                };
                return { ...props.actionButton, props: actionButtonProps };
            } else {
                return null;
            }
        }

        function generateFooter() {
            if (props.actionButton === undefined) {
                return (
                    <Modal.Actions className={footerClassName}>
                        &nbsp;
                    </Modal.Actions>
                );
            } else {
              return (
                  <Modal.Actions className={footerClassName + ' text-align-center'}>
                      {getActionButton()}
                  </Modal.Actions>
              );
            } 
        }

        return (
            <Modal open={this.props.open} {...this.props.modalProps}>
                <Modal.Header className="modal-header">
                    <h1>{this.props.headerText}</h1>
                    {
                        this.props.showHeaderClose ?
                            <Image
                                className="close-button"
                                onClick={this.props.closeHandler}
                                src="./icons/close.svg"
                            />
                        :
                        null
                    }
                    
                </Modal.Header>
                <Modal.Content className="modal-body">
                    {this.props.children}
                </Modal.Content>
                {generateFooter()}
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/base-modal/component.tsx